export default __webpack_public_path__ + "static/media/slider1.f7188ad8.png";